import React from 'react';
import { Card, Avatar, Typography } from 'antd';
import Review from '../../models/Review';
import { BlocksRenderer } from '@strapi/blocks-react-renderer';
import { useData } from '../../contexts/DataContext';

const { Meta } = Card;
const { Title } = Typography;


const ReviewCard: React.FC<{ review: Review }> = ({ review }) => {
    const { state } = useData();
    return (
        <Card style={{ width: '100%', maxWidth: '300px', margin: 'auto', padding: '10px' }}>
            <Meta
                avatar={<Avatar>{review.Name.charAt(0)}</Avatar>}
                title={<Title level={5} style={{ margin: 0 }}>{review.Name}</Title>}
                description={<BlocksRenderer content={review.Review}></BlocksRenderer>}
            />
            <div style={{ marginTop: '16px' }}>
                <img
                  src={state.baseApiPath + review.KeyImage.url}
                  style={{ width: '100%', objectFit: 'cover' }}
                  alt={review.Name}
                />
            </div>
        </Card>
    );
};

export default ReviewCard;
